import { computed, inject, type Provider } from '@angular/core';
import { Router } from '@angular/router';
import { APP_QUIPPY_HOME_ACTIONS } from '@quipex/feature/app-quippy/suggestions';
import { injectInviteOrganisationUsersEntry } from '@quipex/feature/organisations/manage-organisation-users-entry';
import type { HomeSummaryLink } from '@quipex/feature/quippy-conversation';

export function provideHomeSuggestedActions(): Provider {
    return {
        provide: APP_QUIPPY_HOME_ACTIONS,
        useFactory: () => {
            const invite = injectInviteOrganisationUsersEntry();
            const buildingsTarget = inject(Router).createUrlTree([
                '/buildings',
            ]);

            return computed<readonly HomeSummaryLink[]>(() => [
                ...(invite.available()
                    ? [
                          {
                              id: 'invite-organisation-users',
                              title: 'Invite users',
                              description: 'Add people to your org',
                              target: invite.target,
                              appearance: {
                                  icon: 'lucideUserPlus',
                                  context: 'success' as const,
                              },
                          },
                      ]
                    : []),
                {
                    id: 'view-buildings',
                    title: 'View buildings',
                    description: 'Explore your building portfolio',
                    target: buildingsTarget,
                    appearance: { icon: 'lucideBuilding2', context: 'warning' },
                },
            ]);
        },
    };
}
